import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { vaultStoreActions } from '@app/root-store';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { Store } from '@ngrx/store';

@AutoUnsubscribe()
@Component({
  selector: 'manage-shared-vault-members',
  templateUrl: './manage-shared-vault-members.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageSharedVaultMembersComponent implements OnInit {
  userId;
  userObject;
  stateObject;
  make_owner_enabled = false;
  constructor(private dialogRef: MatDialogRef<ManageSharedVaultMembersComponent>, private store: Store, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    this.userId = this.data?.userId;
    this.userObject = {
      id: this.userId,
    };
    this.stateObject = {
      id: this.data.vaultId,
    };
    this.make_owner_enabled = this.data?.make_owner_enabled ?? false;
  }

  closeDialog() {
    this.dialogRef.close();
    this.store.dispatch(new vaultStoreActions.GetVaultRequestAction(this.userId, false));
  }
}
